/* eslint-disable @typescript-eslint/naming-convention */
export const edit = {
  placeholder: 'Add a note',
  assignment_instructions_warning: 'This note is an assignment instruction. Changes made here are visible to all students.',
};
